<template>
  <div v-wechat-title="titleTop" class="page-container">
    <header class="header">
      <div class="header-content">
        <div class="back-btn" @click="goBack">
          <van-icon name="arrow-left" size="20" />
        </div>
        <h1 class="page-title">{{ $t('title') }}</h1>
        <languageChangeVue />
      </div>
    </header>

    <main class="main-content">
      <van-skeleton title avatar :row="10" :loading="loading">
        
        <div v-if="isError" class="error-banner">
          {{ $t('error_msg') }}
        </div>

        <div v-else class="form-content">
          
          <section class="section-card">
            <div class="section-header">
              <van-icon name="manager" class="section-icon" />
              <h2 class="section-title">{{ $t('basic_info') }}</h2>
            </div>
            <div class="section-body">
              
              <div class="form-item">
                <label class="form-label">{{ $t('passport_no') }} <span class="required">*</span></label>
                <input v-model="data.student.passportNumber" type="text" class="form-input" :placeholder="$t('ph_passport_no')" maxlength="32" />
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('id_card') }}</label>
                <input v-model="data.student.idCardNumber" type="text" class="form-input" placeholder="请输入身份证号" maxlength="32" />
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('passport_issue') }} <span class="required">*</span></label>
                <div class="form-input select-input" @click="showPassportCountry = true">
                   <span :class="{'placeholder': !data.expand.passportCountry}">{{ data.expand.passportCountry || $t('ph_select') }}</span>
                   <van-icon name="arrow-down" />
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('passport_valid') }} <span class="required">*</span></label>
                <div class="form-input select-input" @click="openDatePicker('passportFinish')">
                  <span :class="{'placeholder': !passportFinishDisplay}">{{ passportFinishDisplay || $t('ph_select') }}</span>
                  <van-icon name="calendar-o" />
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('passport_page') }} <span class="required">*</span></label>
                <div class="upload-area">
                  <van-uploader v-model="filePassportList" :max-count="1" :after-read="afterReadPassport">
                    <div class="upload-box">
                      <van-icon name="photograph" size="24" color="#9ca3af" />
                      <span class="upload-text">{{ $t('camera') }}</span>
                    </div>
                  </van-uploader>
                </div>
                <p class="helper-text">{{ $t('tip_passport') }}</p>
              </div>

            </div>
          </section>

          <section class="section-card">
            <div class="section-header">
              <van-icon name="shield-o" class="section-icon" />
              <h2 class="section-title">{{ $t('insurance_info') }}</h2>
            </div>
            <div class="section-body">
              
              <div class="form-item">
                <label class="form-label">{{ $t('ins_company') }} <span class="required">*</span></label>
                <input v-model="data.expand.insuranceComplane" maxlength="128" type="text" class="form-input" :placeholder="$t('ph_ins_company')" />
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('ins_phone') }} <span class="required">*</span></label>
                <input v-model="data.expand.insurancePhone" maxlength="64" type="text" class="form-input" :placeholder="$t('ph_ins_phone')" />
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('ins_valid') }} <span class="required">*</span></label>
                <div class="form-input select-input" @click="openDatePicker('insuranceFinish')">
                  <span :class="{'placeholder': !insuranceFinishDisplay}">{{ insuranceFinishDisplay || $t('ph_select') }}</span>
                  <van-icon name="calendar-o" />
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('ins_no') }} <span class="required">*</span></label>
                <input v-model="data.expand.insuranceCode" maxlength="64" type="text" class="form-input" :placeholder="$t('ph_ins_no')" />
              </div>

              <div class="form-item">
                <label class="form-label">{{ $t('ins_file') }} <span class="required">*</span></label>
                <div class="upload-group">
                  <van-uploader v-model="fileInsuranceList" :max-count="1" accept="image/*" :after-read="afterReadInsurance">
                    <div class="upload-box">
                      <van-icon name="photograph" size="24" color="#9ca3af" />
                      <span class="upload-text">{{ $t('camera') }}</span>
                    </div>
                  </van-uploader>
                  <van-uploader v-model="fileInsurancePdfList" :max-count="1" accept=".pdf" :after-read="afterReadInsurancePDF" class="ml-2">
                    <div class="upload-box">
                      <van-icon name="description" size="24" color="#9ca3af" />
                      <span class="upload-text">PDF</span>
                    </div>
                  </van-uploader>
                </div>
                <p class="helper-text">{{ $t('tip_ins') }}</p>
              </div>

            </div>
          </section>

          <section class="section-card">
            <div class="section-header">
              <van-icon name="info-o" class="section-icon" />
              <h2 class="section-title">{{ $t('supp_info') }}</h2>
            </div>
            <div class="section-body no-gap">
              
              <div class="form-row">
                <div class="row-label">
                  <van-icon name="bar-chart-o" class="row-icon" />
                  <span>{{ $t('height') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.height" type="text" class="row-input" maxlength="32" placeholder="cm" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="aim" class="row-icon" />
                  <span>{{ $t('weight') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.weight" type="text" class="row-input" maxlength="32" placeholder="kg" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="apps-o" class="row-icon" />
                  <span>{{ $t('shoe_size') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.shoeSize" type="text" class="row-input" maxlength="32" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="award-o" class="row-icon" />
                  <span>{{ $t('dive_org') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.nowLicense" type="text" class="row-input" placeholder="PADI AOW..." maxlength="32" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="wap-nav" class="row-icon" />
                  <span>{{ $t('dive_total') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.totalDiving" type="text" class="row-input" maxlength="32" />
              </div>

              <div class="form-row" @click="openDatePicker('lastDiveDate')">
                <div class="row-label">
                  <van-icon name="todo-list-o" class="row-icon" />
                  <span>{{ $t('last_dive') }} <span class="required">*</span></span>
                </div>
                <div class="row-value">{{ lastDiveDateDisplay || $t('ph_select_short') }}</div>
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="contact" class="row-icon" />
                  <span>{{ $t('contact_name') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.emergencyName" type="text" class="row-input" maxlength="16" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="phone-o" class="row-icon" />
                  <span>{{ $t('contact_phone') }} <span class="required">*</span></span>
                </div>
                <input v-model="data.student.emergencyContact" type="text" class="row-input" maxlength="32" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="envelope-o" class="row-icon" />
                  <span>{{ $t('email') }}</span>
                </div>
                <input v-model="data.student.email" type="email" class="row-input" maxlength="128" placeholder="example@email.com" />
              </div>
              <div class="form-row">
                <div class="row-label">
                  <van-icon name="envelope-o" class="row-icon" />
                  <span>{{ $t('guardianEmail') }}</span>
                </div>
                <input v-model="data.student.guardianEmail" type="email" class="row-input" maxlength="128" :placeholder="$t('guardianEmailPh')" />
              </div>
              <div class="form-row">
                <div class="row-label">
                  <van-icon name="phone-o" class="row-icon" />
                  <span>{{ $t('phone') }}</span>
                </div>
                <input v-model="data.student.phone" type="tel" class="row-input" maxlength="32" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="location-o" class="row-icon" />
                  <span>{{ $t('address') }}</span>
                </div>
                <input v-model="data.student.address" type="text" class="row-input" maxlength="256" />
              </div>

              <div class="form-row">
                <div class="row-label">
                  <van-icon name="comment-o" class="row-icon" />
                  <span>{{ $t('social_media') }}</span>
                </div>
                <input v-model="data.student.socialMediaAccount" type="text" class="row-input" maxlength="256" placeholder="微信/WhatsApp/Line" />
              </div>

              <div class="form-row border-none">
                <div class="row-label">
                  <van-icon name="comment-o" class="row-icon" />
                  <span>{{ $t('remark') }}</span>
                </div>
                <input v-model="data.expand.remark" type="text" maxlength="1024" class="row-input" :placeholder="$t('ph_remark')" />
              </div>

            </div>
          </section>

          <section class="section-card" v-if="data.expand.isArriveLock">
            <div class="section-header">
              <van-icon name="logistics" class="section-icon" />
              <h2 class="section-title">{{ $t('arrive_info') }}</h2>
            </div>
            <div class="section-body">
              
              <div class="form-item">
                <label class="form-label">{{ $t('arrive_type') }} <span class="required">*</span></label>
                <div class="tags-group">
                  <div class="tag-btn" :class="{active: data.expand.arriveType === 'UNSELECTED'}" @click="data.expand.arriveType = 'UNSELECTED'">{{ $t('opt_unselected') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.arriveType === 'PORT'}" @click="data.expand.arriveType = 'PORT'">{{ $t('opt_port') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.arriveType === 'HOTEL'}" @click="data.expand.arriveType = 'HOTEL'">{{ $t('opt_hotel') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.arriveType === 'NEEDLESS'}" @click="data.expand.arriveType = 'NEEDLESS'">{{ $t('opt_needless') }}</div>
                </div>
              </div>

              <template v-if="data.expand.arriveType === 'PORT'">
                <div class="sub-section">
                  <div class="form-item">
                    <label class="form-label">{{ $t('airport_name') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="hotel-o" class="input-icon" />
                      <input v-model="data.expand.arriveName" maxlength="128" type="text" class="form-input pl-10" :placeholder="$t('ph_airport')" />
                    </div>
                  </div>
                  <div class="form-item">
                    <label class="form-label">{{ $t('arrive_time') }} <span class="required">*</span></label>
                    <div class="form-input select-input" @click="openDateTimePicker('arriveDate')">
                       <span>{{ arriveDateDisplay || $t('ph_select_time') }}</span>
                       <van-icon name="clock-o" />
                    </div>
                  </div>
                  <div class="form-item">
                    <label class="form-label">{{ $t('flight_no') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="label-o" class="input-icon" />
                      <input v-model="data.expand.arriveCode" maxlength="64" type="text" class="form-input pl-10" placeholder="FD156" />
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="data.expand.arriveType === 'HOTEL'">
                <div class="sub-section">
                  <div class="form-item">
                    <label class="form-label">{{ $t('hotel_name') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="hotel-o" class="input-icon" />
                      <input v-model="data.expand.arriveName" type="text" maxlength="128" class="form-input pl-10" :placeholder="$t('ph_hotel')" />
                    </div>
                  </div>
                </div>
              </template>

              <div class="form-item" v-if="data.expand.arriveType !== 'UNSELECTED' && data.expand.arriveType !== 'NEEDLESS'">
                <label class="form-label">{{ $t('arrive_remark') }}</label>
                <input v-model="data.expand.arriveRemark" maxlength="128" type="text" class="form-input" :placeholder="$t('ph_arrive_remark')" />
              </div>

            </div>
          </section>

          <section class="section-card" v-if="data.expand.isDepartLock">
            <div class="section-header">
              <van-icon name="logistics" class="section-icon flip-icon" />
              <h2 class="section-title">{{ $t('depart_info') }}</h2>
            </div>
            <div class="section-body">
              
              <div class="form-item">
                <label class="form-label">{{ $t('depart_type') }} <span class="required">*</span></label>
                <div class="tags-group">
                  <div class="tag-btn" :class="{active: data.expand.departType === 'UNSELECTED'}" @click="data.expand.departType = 'UNSELECTED'">{{ $t('opt_unselected') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.departType === 'PORT'}" @click="data.expand.departType = 'PORT'">{{ $t('opt_port') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.departType === 'HOTEL'}" @click="data.expand.departType = 'HOTEL'">{{ $t('opt_hotel') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.departType === 'NEEDLESS'}" @click="data.expand.departType = 'NEEDLESS'">{{ $t('opt_needless') }}</div>
                </div>
              </div>

              <template v-if="data.expand.departType === 'PORT'">
                 <div class="sub-section">
                  <div class="form-item">
                    <label class="form-label">{{ $t('airport_name') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="hotel-o" class="input-icon" />
                      <input v-model="data.expand.departName" maxlength="128" type="text" class="form-input pl-10" :placeholder="$t('ph_airport')" />
                    </div>
                  </div>
                  <div class="form-item">
                    <label class="form-label">{{ $t('depart_time') }} <span class="required">*</span></label>
                    <div class="form-input select-input" @click="openDateTimePicker('departDate')">
                       <span>{{ departDateDisplay || $t('ph_select_time') }}</span>
                       <van-icon name="clock-o" />
                    </div>
                  </div>
                  <div class="form-item">
                    <label class="form-label">{{ $t('flight_no') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="label-o" class="input-icon" />
                      <input v-model="data.expand.departCode" maxlength="64" type="text" class="form-input pl-10" placeholder="FD156" />
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="data.expand.departType === 'HOTEL'">
                <div class="sub-section">
                   <div class="form-item">
                    <label class="form-label">{{ $t('hotel_name') }} <span class="required">*</span></label>
                    <div class="input-with-icon">
                      <van-icon name="hotel-o" class="input-icon" />
                      <input v-model="data.expand.departName" maxlength="128" type="text" class="form-input pl-10" :placeholder="$t('ph_hotel')" />
                    </div>
                  </div>
                </div>
              </template>

              <div class="form-item" v-if="data.expand.departType !== 'UNSELECTED' && data.expand.departType !== 'NEEDLESS'">
                <label class="form-label">{{ $t('depart_remark') }}</label>
                <input v-model="data.expand.departRemark" maxlength="128" type="text" class="form-input" :placeholder="$t('ph_depart_remark')" />
              </div>

            </div>
          </section>

          <section class="section-card">
            <div class="section-header">
              <van-icon name="bag-o" class="section-icon" />
              <h2 class="section-title">{{ $t('equip_rent') }}</h2>
            </div>
            <div class="section-body">
              
              <div class="form-item">
                <label class="form-label">{{ $t('equip_rent_label') }} <span class="required">*</span></label>
                <div class="tags-group">
                  <div class="tag-btn" :class="{active: data.expand.isNeedEquip === false}" @click="data.expand.isNeedEquip = false">{{ $t('opt_own_equip') }}</div>
                  <div class="tag-btn" :class="{active: data.expand.isNeedEquip === true}" @click="data.expand.isNeedEquip = true">{{ $t('opt_need_rent') }}</div>
                </div>
              </div>

              <template v-if="data.expand.isNeedEquip === true">
                <div class="sub-section">
                  <label class="form-label">{{ $t('equip_select') }} <span class="required">*</span></label>
                  <div class="tags-group">
                    <div 
                      v-for="(item, index) in equipDefault" 
                      :key="index"
                      class="tag-btn check-tag"
                      :class="{active: equipList.includes(item)}"
                      @click="toggleEquip(item)"
                    >
                      <van-icon v-if="equipList.includes(item)" name="success" class="mr-1" />
                      {{ getEquipLabel(item) }}
                    </div>
                  </div>
                </div>
              </template>

            </div>
          </section>

        </div>
      </van-skeleton>
    </main>

    <div class="footer-bar" v-if="!isError">
      <div class="footer-inner">
        <button class="footer-btn secondary" :disabled="loading || data.expand.isManageLock || data.expand.isUserLock" @click="saveFormdata(false)">
          {{ $t('btn_save') }}
        </button>
        <button class="footer-btn primary" :disabled="loading || data.expand.isManageLock || data.expand.isUserLock" @click="saveFormdata(true)">
          {{ $t('btn_submit') }}
        </button>
      </div>
    </div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDateTemp"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirmDate"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <van-popup v-model="showDateTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDateTimeTemp"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirmDateTime"
        @cancel="showDateTimePicker = false"
      />
    </van-popup>

    <van-popup v-model="showPassportCountry" position="bottom">
      <van-picker
        show-toolbar
        :columns="selectPassportCountryOption"
        @confirm="onConfirmPassportCountry"
        @cancel="showPassportCountry = false"
      />
    </van-popup>

    <van-popup v-model="showSuccessModal" class="success-modal">
      <div class="modal-content">
        <div class="success-icon-bg">
          <van-icon name="success" color="#fff" size="24" />
        </div>
        <h3 class="modal-title">{{ $t('success_title') }}</h3>
        <p class="modal-desc">{{ $t('success_desc') }}</p>
        <button class="modal-btn" @click="handleSuccessClose">{{ $t('btn_ok') }}</button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import request from '@/utils/request'
import { isEmptyStr, compressorImageList, formatDate, MyNotify,GetDiveTitle  } from '@/utils/base'
import { Button, Field, Popup, Uploader, Dialog, Skeleton, Icon, DatetimePicker, Picker } from 'vant'
import languageChangeVue from '@/components/languageChange.vue'

// --- 翻译字典 ---
const translations = {
  'zh': {
    title: '出海信息申报',
    error_msg: '请先通过绑定链接绑定后才可以进行修改。\n如需帮助请联系客服。',
    basic_info: '基本信息',
    passport_no: '护照号码',
    id_card: '身份证号码',
    passport_issue: '护照签发地',
    passport_valid: '护照有效期',
    passport_page: '护照首页',
    ph_passport_no: '请输入护照号码',
    ph_select: '请选择',
    camera: '拍照',
    tip_passport: '请上传清晰的护照首页',
    
    insurance_info: '保单',
    ins_company: '保险公司名称',
    ins_phone: '保险联系电话',
    ins_valid: '保险截止日期',
    ins_no: '保单号',
    ins_file: '保单文件',
    ph_ins_company: '保险公司名称',
    ph_ins_phone: '保险公司联系电话',
    ph_ins_no: '请输入保单号',
    tip_ins: '请上传保险订单首页截图或PDF',

    supp_info: '补充信息',
    height: '身高(厘米)',
    weight: '体重(公斤)',
    shoe_size: '鞋码',
    dive_org: '潜水组织和证书',
    dive_total: '总潜水次数',
    last_dive: '最后一次潜水时间',
    contact_name: '紧急联系人',
    contact_phone: '紧急联系方式',
    email: '电子邮箱',
    guardianEmail: '监护人邮箱',
    guardianEmailPh:'未满18岁必须填写',
    phone: '联系电话',
    address: '联系地址',
    social_media: '社交媒体账号',
    remark: '备注',
    ph_select_short: '请选择',
    ph_remark: '如过敏或饮食禁忌',

    arrive_info: '抵达信息',
    arrive_type: '抵达类型',
    opt_unselected: '未选择',
    opt_port: '机场港口',
    opt_hotel: '酒店',
    opt_needless: '无需接送',
    airport_name: '机场名称',
    arrive_time: '抵达时间',
    flight_no: '航班号',
    hotel_name: '酒店名称',
    ph_airport: '机场港口名称(英文)仅填写名称,勿填地址',
    ph_hotel: '酒店名称(英文)仅填写名称,勿填地址',
    ph_select_time: '选择日期和时间',
    arrive_remark: '抵达备注',
    ph_arrive_remark: '其他抵达相关信息',

    depart_info: '离开信息',
    depart_type: '离开类型',
    depart_time: '离开时间',
    depart_remark: '离开备注',
    ph_depart_remark: '其他离开相关信息',

    equip_rent: '装备租赁',
    equip_rent_label: '装备租赁',
    opt_own_equip: '自带装备',
    opt_need_rent: '需要租赁',
    equip_select: '选择需要租赁的装备',

    btn_save: '保存',
    btn_submit: '提交申请',
    btn_ok: '好的',
    success_title: '提交成功',
    success_desc: '已收到您的申报信息',
  },
  'en': {
    title: 'Guest Information Form',
    error_msg: 'Please bind first via the link to modify.\nContact support for help.',
    basic_info: 'Basic Info',
    passport_no: 'Passport No.',
    id_card: 'ID Card No.',
    passport_issue: 'Issue Place',
    passport_valid: 'Expiry Date',
    passport_page: 'Passport Page',
    ph_passport_no: 'Enter passport number',
    ph_select: 'Select',
    camera: 'Camera',
    tip_passport: 'Upload clear passport photo page',
    
    insurance_info: 'Insurance',
    ins_company: 'Insurance Company',
    ins_phone: 'Insurance Phone',
    ins_valid: 'Expiry Date',
    ins_no: 'Policy No.',
    ins_file: 'Policy File',
    ph_ins_company: 'Company Name',
    ph_ins_phone: 'Contact Phone',
    ph_ins_no: 'Enter Policy No.',
    tip_ins: 'Upload policy screenshot or PDF',

    supp_info: 'Supplement Info',
    height: 'Height (cm)',
    weight: 'Weight (kg)',
    shoe_size: 'Shoe Size',
    dive_org: 'Certification',
    dive_total: 'Total Dives',
    last_dive: 'Last Dive Date',
    contact_name: 'Emergency Contact',
    contact_phone: 'Emergency Phone',
    email: 'Email',
    guardianEmail: 'Guardian Email',
    guardianEmailPh:'If under 18, must fill in.',
    phone: 'Phone',
    address: 'Address',
    social_media: 'Social Media',
    remark: 'Notes',
    ph_select_short: 'Select',
    ph_remark: 'Allergies or dietary request',

    arrive_info: 'Arrival Info',
    arrive_type: 'Arrival Type',
    opt_unselected: 'Not Selected',
    opt_port: 'Airport/Port',
    opt_hotel: 'Hotel',
    opt_needless: 'No Transfer',
    airport_name: 'Airport Name',
    arrive_time: 'Arrival Time',
    flight_no: 'Flight No.',
    hotel_name: 'Hotel Name',
    ph_airport: 'Airport/Port Name (English)',
    ph_hotel: 'Hotel Name (English)',
    ph_select_time: 'Select Date & Time',
    arrive_remark: 'Arrival Remarks',
    ph_arrive_remark: 'Other arrival info',

    depart_info: 'Departure Info',
    depart_type: 'Departure Type',
    depart_time: 'Departure Time',
    depart_remark: 'Departure Remarks',
    ph_depart_remark: 'Other departure info',

    equip_rent: 'Equipment',
    equip_rent_label: 'Rental Option',
    opt_own_equip: 'Own Equipment',
    opt_need_rent: 'Need Rental',
    equip_select: 'Select Equipment',

    btn_save: 'Save',
    btn_submit: 'Submit',
    btn_ok: 'OK',
    success_title: 'Submitted!',
    success_desc: 'We have received your information',
  }
};

// 装备名称映射
const equipMap = {
  '全套装备(不含电脑表)': { en: 'Full Set (No Computer)' },
  '全套装备(含电脑表)': { en: 'Full Set (With Computer)' },
  'BCD': { en: 'BCD' },
  '调节器': { en: 'Regulator' },
  '面镜': { en: 'Mask' },
  '15L加大气瓶': { en: '15L Tank' },
  '潜水电脑表': { en: 'Dive Computer' },
  '脚蹼': { en: 'Fins' },
  '湿衣': { en: 'Wetsuit' },
  '手电': { en: 'Torch' },
  '使⽤高氧': { en: 'Nitrox' },
  '私⼈潜导': { en: 'Private Guide' }
};

export default {
  name: 'LiveaboardExpand',
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Skeleton.name]: Skeleton,
    [Icon.name]: Icon,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    languageChangeVue
  },
  data() {
    return {
      titleTop:'',
      loading: true,
      buttonLoading: false,
      isError: false,
      id: undefined,
      
      // 数据结构
      data: {
        student: {},
        expand: {}
      },

      // 临时变量与UI控制
      passportFinishDisplay: '',
      insuranceFinishDisplay: '',
      lastDiveDateDisplay: '',
      arriveDateDisplay: '',
      departDateDisplay: '',

      // 弹窗控制
      showDatePicker: false,
      showDateTimePicker: false,
      showPassportCountry: false,
      showSuccessModal: false,

      // 选择器当前操作的字段名
      activeField: '',
      currentDateTemp: new Date(),
      currentDateTimeTemp: new Date(),

      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2050, 11, 31),

      // 国家列表
      selectPassportCountryOption: [],

      // 文件列表
      filePassportList: [],
      fileInsuranceList: [],
      fileInsurancePdfList: [],

      // 装备
      equipList: [],
      equipDefault: ['全套装备(不含电脑表)','全套装备(含电脑表)','BCD','调节器','面镜','15L加大气瓶','潜水电脑表','脚蹼','湿衣','手电','使⽤高氧','私⼈潜导'],
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.user.currentLang
    }
  },
  created() {
    this.id = this.$route.params.id
    this.titleTop = GetDiveTitle()
    this.initCountry(() => {
      this.init()
      this.titleTop = GetDiveTitle()
    })
  },
  methods: {
    $t(key) {
      return translations[this.currentLang][key] || key;
    },
    getEquipLabel(item) {
      if (this.currentLang === 'en' && equipMap[item]) {
        return equipMap[item].en;
      }
      return item;
    },

    goBack() {
      window.history.back();
    },

    initCountry(callback) {
      request({ url: '/data/getCountryList', method: 'post' }).then(res => {
        if (res.success) {
          this.selectPassportCountryOption = [{ text: "其他", value: "其他" }]
          res.data.forEach(el => {
            this.selectPassportCountryOption.push({ text: el.name, value: el.name })
          })
          if (callback) callback()
        }
      })
    },
    init() {
      this.loading = true
      request({
        url: '/storeHelper/getLiveaboardExpandInfo',
        method: 'post',
        params: { id: this.id }
      }).then(res => {
        this.loading = false
        if (!res.success) {
          this.isError = true
          MyNotify('error', '读取数据失败!', 2000)
          return
        }
        this.isError = false
        this.data = res.data

        if(this.data.expand && this.data.expand.equipList){
          this.equipList = this.data.expand.equipList.split(',')
        } else {
          this.equipList = []
        }

        this.formatInitialDate('passportFinish', this.data.expand.passportFinish, 'yyyy/MM/dd')
        this.formatInitialDate('insuranceFinish', this.data.expand.insuranceFinish, 'yyyy/MM/dd')
        this.formatInitialDate('lastDiveDate', this.data.student.lastDiveDate, 'yyyy/MM/dd')
        this.formatInitialDate('arriveDate', this.data.expand.arriveDate, 'yyyy/MM/dd hh:mm', true)
        this.formatInitialDate('departDate', this.data.expand.departDate, 'yyyy/MM/dd hh:mm', true)

        this.filePassportList = this.data.expand.passportImg ? [{url: this.data.expand.passportImg}] : []
        this.fileInsuranceList = []
        this.fileInsurancePdfList = []
        if(this.data.expand.insuranceImg) {
          if(this.data.expand.insuranceImg.toLowerCase().indexOf(".pdf") > 0) {
            this.fileInsurancePdfList.push({url: this.data.expand.insuranceImg})
          } else {
            this.fileInsuranceList.push({url: this.data.expand.insuranceImg})
          }
        }

        if(this.data.expand.isManageLock || this.data.expand.isUserLock)
        {
          MyNotify('error', '信息已经提交,无法修改,如需修改请联系客服!', 6000)
          return
        }
      })
    },
    formatInitialDate(field, val, fmt, isTime = false) {
      if (!val) return
      const displayVal = formatDate(val, fmt)
      if (field === 'passportFinish') this.passportFinishDisplay = displayVal
      if (field === 'insuranceFinish') this.insuranceFinishDisplay = displayVal
      if (field === 'lastDiveDate') this.lastDiveDateDisplay = displayVal
      if (field === 'arriveDate') this.arriveDateDisplay = displayVal
      if (field === 'departDate') this.departDateDisplay = displayVal
    },

    openDatePicker(field) {
      this.activeField = field
      this.showDatePicker = true
    },
    onConfirmDate(date) {
      const display = formatDate(date, 'yyyy/MM/dd')
      if(this.activeField === 'passportFinish') {
        this.data.expand.passportFinish = display
        this.passportFinishDisplay = display
      }
      if(this.activeField === 'insuranceFinish') {
        this.data.expand.insuranceFinish  = display
        this.insuranceFinishDisplay = display
      }
      if(this.activeField === 'lastDiveDate') {
        this.data.student.lastDiveDate  = display
        this.lastDiveDateDisplay = display
      }
      this.showDatePicker = false
    },
    openDateTimePicker(field) {
      this.activeField = field
      this.showDateTimePicker = true
    },
    onConfirmDateTime(date) {
      const display = formatDate(date, 'yyyy/MM/dd hh:mm')
      if(this.activeField === 'arriveDate') {
        this.data.expand.arriveDate = display
        this.arriveDateDisplay = display
      }
      if(this.activeField === 'departDate') {
        this.data.expand.departDate = display
        this.departDateDisplay = display
      }
      this.showDateTimePicker = false
    },

    onConfirmPassportCountry(val) {
      this.data.expand.passportCountry = val.value
      this.showPassportCountry = false
    },

    toggleEquip(item) {
      const idx = this.equipList.indexOf(item)
      if (idx >= 0) {
        this.equipList.splice(idx, 1)
      } else {
        this.equipList.push(item)
      }
    },

    afterReadPassport(file) {},
    afterReadInsurance(file) {
      if (this.fileInsurancePdfList && this.fileInsurancePdfList.length) {
        this.fileInsurancePdfList = []
      }
      this.data.expand.insuranceImg = ''
    },
    afterReadInsurancePDF(file) {
      if (this.fileInsuranceList && this.fileInsuranceList.length) {
        this.fileInsuranceList = []
      }
      this.data.expand.insuranceImg = ''
    },

    async uploadPassportImg(callback) {
      const urlStr = await this._uploadFromVantList(this.filePassportList, { compressImage: true })
      this.data.expand.passportImg = urlStr
      this.filePassportList = urlStr ? urlStr.split(',').filter(Boolean).map(url => ({ url })) : []
      if (callback) callback(urlStr)
      return urlStr
    },

    async uploadInsuranceImg(callback) {
      const urlStr = await this._uploadFromVantList(this.fileInsuranceList, { compressImage: true })
      this.data.expand.insuranceImg = urlStr
      this.fileInsuranceList = urlStr ? urlStr.split(',').filter(Boolean).map(url => ({ url })) : []
      if (callback) callback(urlStr)
      return urlStr
    },

    async uploadInsurancePDF(callback) {
      const urlStr = await this._uploadFromVantList(this.fileInsurancePdfList, { compressImage: false })
      this.data.expand.insuranceImg = urlStr
      this.fileInsurancePdfList = urlStr ? urlStr.split(',').filter(Boolean).map(url => ({ url })) : []
      if (callback) callback(urlStr)
      return urlStr
    },

    async _uploadFromVantList(vantList, { compressImage }) {
      const list = Array.isArray(vantList) ? vantList : []
      const newItems = list.filter(item => item && item.file)
      const hasNewFile = newItems.length > 0

      if (!hasNewFile) {
        return list
          .filter(item => item && item.url)
          .map(item => item.url)
          .join(',')
      }

      const keepUrls = list
        .filter(item => item && !item.file && item.url)
        .map(item => item.url)

      const formData = new FormData()

      if (compressImage) {
        const rawFiles = newItems.map(item => item.file)
        const compressedList = await new Promise((resolve) => {
          compressorImageList(rawFiles, 2048, 2048, 0.6, (out) => resolve(out || []))
        })
        compressedList.forEach(v => {
          if (!v || !v.file) return
          if (v.name) formData.append('file', v.file, v.name)
          else formData.append('file', v.file)
        })
      } else {
        newItems.forEach(item => {
          if (!item || !item.file) return
          const f = item.file
          if (f && f.name) formData.append('file', f, f.name)
          else formData.append('file', f)
        })
      }

      const res = await request({
        url: '/Data/uploadFile?config=liveaboardmanage',
        method: 'post',
        data: formData
      })

      if (!res || !res.success) {
        const msg = (res && (res.message || res.msg)) ? (res.message || res.msg) : '文件上传失败'
        throw new Error(msg)
      }

      const newUrls = Array.isArray(res.data) ? res.data.map(v => v && v.save).filter(Boolean) : []
      return [...keepUrls, ...newUrls].join(',')
    },
    
    validateForm() {
      const d = this.data;
      const s = d.student;
      const e = d.expand;

      if (!s.passportNumber) return '请输入护照号码';
      if (!e.passportCountry) return '请选择护照签发地';
      if (!e.passportFinish) return '请选择护照有效期';
      if (this.filePassportList.length === 0) return '请上传护照首页照片';

      if (!e.insuranceComplane) return '请输入保险公司名称';
      if (!e.insurancePhone) return '请输入保险联系电话';
      if (!e.insuranceFinish) return '请选择保险截止日期';
      if (!e.insuranceCode) return '请输入保单号';
      if (this.fileInsuranceList.length === 0 && this.fileInsurancePdfList.length === 0) return '请上传保单文件';

      if (!s.height) return '请输入身高';
      if (!s.weight) return '请输入体重';
      if (!s.shoeSize) return '请输入鞋码';
      if (!s.nowLicense) return '请输入潜水组织和证书';
      if (!s.totalDiving) return '请输入总潜水次数';
      if (!s.lastDiveDate) return '请选择最后一次潜水时间';
      if (!s.emergencyName) return '请输入紧急联系人姓名';
      if (!s.emergencyContact) return '请输入紧急联系方式';

      if (e.isArriveLock) {
        if (!e.arriveType || e.arriveType === 'UNSELECTED') return '请选择抵达类型';
        if (e.arriveType === 'PORT') {
          if (!e.arriveName) return '请输入抵达机场/港口名称';
          if (!e.arriveDate) return '请选择抵达时间';
          if (!e.arriveCode) return '请输入抵达航班号';
        }
        if (e.arriveType === 'HOTEL') {
          if (!e.arriveName) return '请输入抵达酒店名称';
        }
      }

      if (e.isDepartLock) {
        if (!e.departType || e.departType === 'UNSELECTED') return '请选择离开类型';
        if (e.departType === 'PORT') {
          if (!e.departName) return '请输入离开机场/港口名称';
          if (!e.departDate) return '请选择离开时间';
          if (!e.departCode) return '请输入离开航班号';
        }
        if (e.departType === 'HOTEL') {
          if (!e.departName) return '请输入离开酒店名称';
        }
      }

      if (e.isNeedEquip === true && this.equipList.length === 0) return '请选择需要租赁的装备';

      return null;
    },

    async saveFormdata(isLock) {
      if(isLock){
        const errorMsg = this.validateForm();
        if (errorMsg) {
          MyNotify('error', errorMsg);
          return;
        }
      }

      this.data.expand.isUserLock = isLock
      this.data.expand.equipList = this.equipList.join(',')
      this.data.expand.equipEngList = this.equipList.join(',')

      this.buttonLoading = true

      try {
        await this.uploadPassportImg()

        if (this.fileInsurancePdfList && this.fileInsurancePdfList.length > 0) {
          this.fileInsuranceList = []
          await this.uploadInsurancePDF()
        } else {
          this.fileInsurancePdfList = []
          await this.uploadInsuranceImg()
        }

        const res = await request({
          url: '/StoreHelper/updateLiveaboardExpandInfo',
          method: 'post',
          data: this.data
        })

        this.buttonLoading = false
        if (!res || !res.success) return

        if (isLock) {
          this.showSuccessModal = true
        } else {
          MyNotify('success', '保存成功', 2000)
        }
      } catch (err) {
        this.buttonLoading = false
        MyNotify('error', (err && err.message) ? err.message : '上传或保存失败')
      }
    },
    handleSuccessClose() {
      this.showSuccessModal = false
    }
  }
}
</script>

<style scoped>
/* 保持原有样式不变 */
* { box-sizing: border-box; }

.page-container {
  min-height: 100vh;
  background-color: #f9fafb;
  padding-bottom: 7rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #171717;
}

.header {
  background: white;
  border-bottom: 1px solid #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 40;
}
.header-content {
  max-width: 28rem;
  margin: 0 auto;
  height: 3.5rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.back-btn {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #525252;
  cursor: pointer;
}
.page-title {
  font-size: 1rem;
  font-weight: 600;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

.main-content {
  max-width: 28rem;
  margin: 0 auto;
  padding: 1rem;
}

.error-banner {
  padding: 2rem 1rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.875rem;
  white-space: pre-line;
}

.section-card {
  background: white;
  border-radius: 0.5rem;
  border: 1px solid #f5f5f5;
  overflow: hidden;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f5f5f5;
}
.section-icon {
  color: #2563eb;
  font-size: 1rem;
}
.flip-icon { transform: scaleX(-1); }
.section-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0;
}
.section-body {
  padding: 1.25rem;
}
.section-body.no-gap { padding: 0.5rem 1.25rem; }

.form-item {
  margin-bottom: 1.25rem;
}
.form-item:last-child { margin-bottom: 0; }
.form-label {
  display: block;
  font-size: 0.75rem;
  color: #737373;
  margin-bottom: 0.5rem;
}
.required { color: #ef4444; margin-left: 2px; }

.form-input {
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: #f9fafb;
  border: 1px solid #e5e5e5;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #171717;
  outline: none;
  transition: border-color 0.2s;
}
.form-input::placeholder { color: #a3a3a3; }
.form-input:focus { border-color: #a3a3a3; }

.select-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #171717;
}
.placeholder { color: #a3a3a3; }

.upload-group { display: flex; align-items: center; }
.ml-2 { margin-left: 0.75rem; }
.upload-box {
  width: 5rem;
  height: 5rem;
  background-color: #f9fafb;
  border: 1px dashed #d4d4d4;
  border-radius: 0.375rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.upload-text { font-size: 0.625rem; color: #a3a3a3; }
.helper-text { font-size: 0.625rem; color: #a3a3a3; margin-top: 0.5rem; }

.form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f5f5f5;
}
.border-none { border-bottom: none; }
.row-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #525252;
}
.row-icon { color: #a3a3a3; font-size: 1rem; }
.row-input {
  text-align: right;
  border: none;
  background: transparent;
  width: 10rem;
  font-size: 0.875rem;
  color: #171717;
  outline: none;
  font-weight: 500;
}
.row-value { font-size: 0.875rem; font-weight: 500; }

.tags-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.tag-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  border: 1px solid #e5e5e5;
  background: white;
  color: #525252;
  cursor: pointer;
  transition: all 0.2s;
}
.tag-btn.active {
  background-color: #2563eb;
  color: white;
  border-color: #2563eb;
}
.check-tag {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}
.check-tag.active {
  background-color: #171717;
  border-color: #171717;
}
.mr-1 { margin-right: 0.25rem; }

.sub-section {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f5f5f5;
}
.input-with-icon { position: relative; }
.input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #a3a3a3;
  z-index: 2;
}
.pl-10 { padding-left: 2.75rem; }

.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #f5f5f5;
  padding: 1rem;
  z-index: 50;
}
.footer-inner {
  max-width: 28rem;
  margin: 0 auto;
  display: flex;
  gap: 0.75rem;
}
.footer-btn {
  flex: 1;
  height: 2.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
}
.footer-btn.secondary {
  background: white;
  border: 1px solid #e5e5e5;
  color: #171717;
}
.footer-btn.primary {
  background: #2563eb;
  color: white;
}
.footer-btn:disabled { opacity: 0.6; }

.success-modal {
  border-radius: 0.5rem;
  width: 85%;
  max-width: 24rem;
  padding: 2rem;
  text-align: center;
}
.success-icon-bg {
  width: 3rem;
  height: 3rem;
  background: #2563eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem auto;
}
.modal-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.modal-desc {
  font-size: 0.875rem;
  color: #737373;
  margin-bottom: 1.5rem;
}
.modal-btn {
  width: 100%;
  height: 2.75rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
}
</style>